module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-edit-parking-group"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13dcf296!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/DeleteParkingGroup.vue
// module id = 2288
// module chunks = 1